import { render, staticRenderFns } from "./AssignedFormulation.vue?vue&type=template&id=05a69654&scoped=true&"
import script from "./AssignedFormulation.vue?vue&type=script&lang=js&"
export * from "./AssignedFormulation.vue?vue&type=script&lang=js&"
import style0 from "./AssignedFormulation.vue?vue&type=style&index=0&id=05a69654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a69654",
  null
  
)

export default component.exports